export default __webpack_public_path__ + "static/product6-65f48558d5a89fd7b247aaf471ccfaae.png";